package chat

/** Only stable provider IDs are persisted; random endpoints never enter history. */
data class CatPhoto(val id: String, val name: String, val createdAt: Double) {
    val url: String get() = "https://cataas.com/cat/$id"

    companion object {
        fun isValidId(id: String): Boolean = id.matches(Regex("[A-Za-z0-9_-]{1,128}"))
    }
}

class CatHistory(initial: List<CatPhoto> = emptyList()) {
    val entries = initial.filter { CatPhoto.isValidId(it.id) && it.createdAt.isFinite() }
        .distinctBy { it.id }.take(100).toMutableList()
    var selectedId: String? = entries.firstOrNull()?.id
    val selected: CatPhoto? get() = entries.firstOrNull { it.id == selectedId }

    fun add(photo: CatPhoto) {
        entries.removeAll { it.id == photo.id }
        entries.add(0, photo)
        while (entries.size > 100) entries.removeAt(entries.lastIndex)
        selectedId = photo.id
    }
}
